module.exports = __webpack_public_path__ + "41ffb8434a67ebb7b622d51e9316588d.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/3 de fierro.png
// module id = 582
// module chunks = 0